export interface DevelopusSnackbarState {
  open: boolean
  message: string
}

export const developusInitialSnackbarState: DevelopusSnackbarState = {
  open: false,
  message: '',
}
